import { render } from "./IndexLOARequestPage.vue?vue&type=template&id=5cd419c1"
import script from "./IndexLOARequestPage.vue?vue&type=script&lang=js"
export * from "./IndexLOARequestPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__